module.exports = __webpack_public_path__ + "static/BannerFinanzas-ae9fbc72e969d242eaf320a9707d121e.png";